//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * (Auth)
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @return Success
     */
    checkUserIsAuthorized(version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/Home/checkUserIsAuthorized";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckUserIsAuthorized(_response);
        });
    }

    protected processCheckUserIsAuthorized(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * (Auth)
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @return Success
     */
    getUserHerds(version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined): Promise<UserHerdDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/Home/getUserHerds";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserHerds(_response);
        });
    }

    protected processGetUserHerds(response: Response): Promise<UserHerdDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserHerdDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserHerdDto[]>(null as any);
    }

    /**
     * (Auth)
     * @param herdId (optional) 
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @return Success
     */
    getAnimalList(herdId: number | undefined, version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined): Promise<MobiLinkAnimalDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/Home/getAnimalList?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (herdId === null)
            throw new Error("The parameter 'herdId' cannot be null.");
        else if (herdId !== undefined)
            url_ += "herdId=" + encodeURIComponent("" + herdId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnimalList(_response);
        });
    }

    protected processGetAnimalList(response: Response): Promise<MobiLinkAnimalDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MobiLinkAnimalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MobiLinkAnimalDto[]>(null as any);
    }

    /**
     * (Auth)
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @return Success
     */
    getUserSettings(version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined): Promise<UserSettingsDto> {
        let url_ = this.baseUrl + "/api/v{version}/Home/getUserSettings";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserSettings(_response);
        });
    }

    protected processGetUserSettings(response: Response): Promise<UserSettingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettingsDto>(null as any);
    }

    /**
     * (Auth)
     * @param herdId (optional) 
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @return Success
     */
    getHerdSettings(herdId: number | undefined, version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined): Promise<HerdSettingsDto> {
        let url_ = this.baseUrl + "/api/v{version}/Home/getHerdSettings?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (herdId === null)
            throw new Error("The parameter 'herdId' cannot be null.");
        else if (herdId !== undefined)
            url_ += "herdId=" + encodeURIComponent("" + herdId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHerdSettings(_response);
        });
    }

    protected processGetHerdSettings(response: Response): Promise<HerdSettingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HerdSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HerdSettingsDto>(null as any);
    }

    /**
     * (Auth)
     * @param herdId (optional) 
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @return Success
     */
    getSentBarcodes(herdId: number | undefined, version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined): Promise<SentBarcodeDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/Home/getSentBarcodes?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (herdId === null)
            throw new Error("The parameter 'herdId' cannot be null.");
        else if (herdId !== undefined)
            url_ += "herdId=" + encodeURIComponent("" + herdId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSentBarcodes(_response);
        });
    }

    protected processGetSentBarcodes(response: Response): Promise<SentBarcodeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SentBarcodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SentBarcodeDto[]>(null as any);
    }

    /**
     * (Auth)
     * @param paramAttName (optional) 
     * @param language (optional) 
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @return Success
     */
    getParamInt(paramAttName: string | undefined, language: string | undefined, version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined): Promise<ParamIntDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/Home/getParamInt?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (paramAttName === null)
            throw new Error("The parameter 'paramAttName' cannot be null.");
        else if (paramAttName !== undefined)
            url_ += "ParamAttName=" + encodeURIComponent("" + paramAttName) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParamInt(_response);
        });
    }

    protected processGetParamInt(response: Response): Promise<ParamIntDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParamIntDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParamIntDto[]>(null as any);
    }

    /**
     * (Auth)
     * @param calcGroup (optional) 
     * @param calcName (optional) 
     * @param calcCode (optional) 
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @return Success
     */
    getParamCalc(calcGroup: string | undefined, calcName: string | undefined, calcCode: string | undefined, version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined): Promise<ParamCalcDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/Home/getParamCalc?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (calcGroup === null)
            throw new Error("The parameter 'calcGroup' cannot be null.");
        else if (calcGroup !== undefined)
            url_ += "CalcGroup=" + encodeURIComponent("" + calcGroup) + "&";
        if (calcName === null)
            throw new Error("The parameter 'calcName' cannot be null.");
        else if (calcName !== undefined)
            url_ += "CalcName=" + encodeURIComponent("" + calcName) + "&";
        if (calcCode === null)
            throw new Error("The parameter 'calcCode' cannot be null.");
        else if (calcCode !== undefined)
            url_ += "CalcCode=" + encodeURIComponent("" + calcCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParamCalc(_response);
        });
    }

    protected processGetParamCalc(response: Response): Promise<ParamCalcDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParamCalcDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParamCalcDto[]>(null as any);
    }

    /**
     * (Auth)
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @param body (optional) 
     * @return Success
     */
    saveBarcodes(version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined, body: SaveBarcodesCommand | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v{version}/Home/saveBarcodes";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBarcodes(_response);
        });
    }

    protected processSaveBarcodes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @param body (optional) 
     * @return Success
     */
    updatePregCheckOrders(version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined, body: UpdatePregnancyCheckOrdersCommand | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v{version}/Home/updatePregCheckOrders";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePregCheckOrders(_response);
        });
    }

    protected processUpdatePregCheckOrders(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @param body (optional) 
     * @return Success
     */
    saveSettings(version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined, body: SaveMobiLinkSettingsCommand | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v{version}/Home/saveSettings";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveSettings(_response);
        });
    }

    protected processSaveSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @param body (optional) 
     * @return Success
     */
    log(version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined, body: LogMessage | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v{version}/Log";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLog(_response);
        });
    }

    protected processLog(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param x_Correlation_ID (optional) Log correlation identifier for the request
     * @param x_Session_ID (optional) Log session identifier for the request
     * @param x_LoadRelatedEntities (optional) Load related entities
     * @param body (optional) 
     * @return Success
     */
    event(version: string, x_Correlation_ID: string | undefined, x_Session_ID: string | undefined, x_LoadRelatedEntities: string | undefined, body: TrackEvent | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v{version}/Log/event";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-Correlation-ID": x_Correlation_ID !== undefined && x_Correlation_ID !== null ? "" + x_Correlation_ID : "",
                "X-Session-ID": x_Session_ID !== undefined && x_Session_ID !== null ? "" + x_Session_ID : "",
                "X-LoadRelatedEntities": x_LoadRelatedEntities !== undefined && x_LoadRelatedEntities !== null ? "" + x_LoadRelatedEntities : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEvent(_response);
        });
    }

    protected processEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error ", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BarcodeDataToSaveDto implements IBarcodeDataToSaveDto {
    bovineId?: number;
    barcode?: number;
    pregCheckOrder?: boolean;
    hasChanged?: boolean | undefined;

    constructor(data?: IBarcodeDataToSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bovineId = _data["bovineId"];
            this.barcode = _data["barcode"];
            this.pregCheckOrder = _data["pregCheckOrder"];
            this.hasChanged = _data["hasChanged"];
        }
    }

    static fromJS(data: any): BarcodeDataToSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeDataToSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bovineId"] = this.bovineId;
        data["barcode"] = this.barcode;
        data["pregCheckOrder"] = this.pregCheckOrder;
        data["hasChanged"] = this.hasChanged;
        return data;
    }
}

export interface IBarcodeDataToSaveDto {
    bovineId?: number;
    barcode?: number;
    pregCheckOrder?: boolean;
    hasChanged?: boolean | undefined;
}

export enum BarcodesSendTo {
    TestMilkingEMM = 1,
    MMfi = 2,
}

export class HerdSettingsDto implements IHerdSettingsDto {
    sendTo?: BarcodesSendTo;
    canOrderPregCheck?: boolean;
    showPregCheckMessage?: boolean;

    constructor(data?: IHerdSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendTo = _data["sendTo"];
            this.canOrderPregCheck = _data["canOrderPregCheck"];
            this.showPregCheckMessage = _data["showPregCheckMessage"];
        }
    }

    static fromJS(data: any): HerdSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new HerdSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendTo"] = this.sendTo;
        data["canOrderPregCheck"] = this.canOrderPregCheck;
        data["showPregCheckMessage"] = this.showPregCheckMessage;
        return data;
    }
}

export interface IHerdSettingsDto {
    sendTo?: BarcodesSendTo;
    canOrderPregCheck?: boolean;
    showPregCheckMessage?: boolean;
}

export enum LogEventLevel {
    Verbose = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
    Fatal = 5,
}

export class LogMessage implements ILogMessage {
    logLevel?: LogEventLevel;
    message?: string | undefined;
    correlation?: string | undefined;
    user?: string | undefined;

    constructor(data?: ILogMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logLevel = _data["logLevel"];
            this.message = _data["message"];
            this.correlation = _data["correlation"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): LogMessage {
        data = typeof data === 'object' ? data : {};
        let result = new LogMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logLevel"] = this.logLevel;
        data["message"] = this.message;
        data["correlation"] = this.correlation;
        data["user"] = this.user;
        return data;
    }
}

export interface ILogMessage {
    logLevel?: LogEventLevel;
    message?: string | undefined;
    correlation?: string | undefined;
    user?: string | undefined;
}

export class MobiLinkAnimalDto implements IMobiLinkAnimalDto {
    bovineId?: number;
    earNr?: number;
    nameShort?: string | undefined;
    euIdentifier!: string;
    euCheck?: string | undefined;
    lastPregCheckDate?: Date | undefined;
    lastPregnancyCode?: number | undefined;
    daysFromInsem?: number | undefined;
    barcode?: number | undefined;
    pregCheckOrder?: boolean | undefined;

    constructor(data?: IMobiLinkAnimalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bovineId = _data["bovineId"];
            this.earNr = _data["earNr"];
            this.nameShort = _data["nameShort"];
            this.euIdentifier = _data["euIdentifier"];
            this.euCheck = _data["euCheck"];
            this.lastPregCheckDate = _data["lastPregCheckDate"] ? new Date(_data["lastPregCheckDate"].toString()) : <any>undefined;
            this.lastPregnancyCode = _data["lastPregnancyCode"];
            this.daysFromInsem = _data["daysFromInsem"];
            this.barcode = _data["barcode"];
            this.pregCheckOrder = _data["pregCheckOrder"];
        }
    }

    static fromJS(data: any): MobiLinkAnimalDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobiLinkAnimalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bovineId"] = this.bovineId;
        data["earNr"] = this.earNr;
        data["nameShort"] = this.nameShort;
        data["euIdentifier"] = this.euIdentifier;
        data["euCheck"] = this.euCheck;
        data["lastPregCheckDate"] = this.lastPregCheckDate ? this.lastPregCheckDate.toISOString() : <any>undefined;
        data["lastPregnancyCode"] = this.lastPregnancyCode;
        data["daysFromInsem"] = this.daysFromInsem;
        data["barcode"] = this.barcode;
        data["pregCheckOrder"] = this.pregCheckOrder;
        return data;
    }
}

export interface IMobiLinkAnimalDto {
    bovineId?: number;
    earNr?: number;
    nameShort?: string | undefined;
    euIdentifier: string;
    euCheck?: string | undefined;
    lastPregCheckDate?: Date | undefined;
    lastPregnancyCode?: number | undefined;
    daysFromInsem?: number | undefined;
    barcode?: number | undefined;
    pregCheckOrder?: boolean | undefined;
}

export class ParamCalcDto implements IParamCalcDto {
    value1!: number;
    value2?: number | undefined;
    value3?: number | undefined;
    value4?: number | undefined;

    constructor(data?: IParamCalcDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value1 = _data["value1"];
            this.value2 = _data["value2"];
            this.value3 = _data["value3"];
            this.value4 = _data["value4"];
        }
    }

    static fromJS(data: any): ParamCalcDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParamCalcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value1"] = this.value1;
        data["value2"] = this.value2;
        data["value3"] = this.value3;
        data["value4"] = this.value4;
        return data;
    }
}

export interface IParamCalcDto {
    value1: number;
    value2?: number | undefined;
    value3?: number | undefined;
    value4?: number | undefined;
}

export class ParamIntDto implements IParamIntDto {
    paramCode!: number;
    name?: string | undefined;

    constructor(data?: IParamIntDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paramCode = _data["paramCode"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ParamIntDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParamIntDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paramCode"] = this.paramCode;
        data["name"] = this.name;
        return data;
    }
}

export interface IParamIntDto {
    paramCode: number;
    name?: string | undefined;
}

export class SaveBarcodesCommand implements ISaveBarcodesCommand {
    herdId?: number;
    userId?: string | undefined;
    sendTo?: BarcodesSendTo;
    barcodes?: BarcodeDataToSaveDto[] | undefined;

    constructor(data?: ISaveBarcodesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.herdId = _data["herdId"];
            this.userId = _data["userId"];
            this.sendTo = _data["sendTo"];
            if (Array.isArray(_data["barcodes"])) {
                this.barcodes = [] as any;
                for (let item of _data["barcodes"])
                    this.barcodes!.push(BarcodeDataToSaveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveBarcodesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBarcodesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["herdId"] = this.herdId;
        data["userId"] = this.userId;
        data["sendTo"] = this.sendTo;
        if (Array.isArray(this.barcodes)) {
            data["barcodes"] = [];
            for (let item of this.barcodes)
                data["barcodes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveBarcodesCommand {
    herdId?: number;
    userId?: string | undefined;
    sendTo?: BarcodesSendTo;
    barcodes?: BarcodeDataToSaveDto[] | undefined;
}

export class SaveMobiLinkSettingsCommand implements ISaveMobiLinkSettingsCommand {
    herdId?: number;
    sendTo?: BarcodesSendTo;
    userId?: string | undefined;

    constructor(data?: ISaveMobiLinkSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.herdId = _data["herdId"];
            this.sendTo = _data["sendTo"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): SaveMobiLinkSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMobiLinkSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["herdId"] = this.herdId;
        data["sendTo"] = this.sendTo;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ISaveMobiLinkSettingsCommand {
    herdId?: number;
    sendTo?: BarcodesSendTo;
    userId?: string | undefined;
}

export class SentBarcodeAnimalDto implements ISentBarcodeAnimalDto {
    bovineId?: number;
    earNr?: number;
    nameShort?: string | undefined;
    euIdentifier?: string | undefined;
    euCheck?: string | undefined;
    lastPregCheckDate?: Date | undefined;
    lastPregnancyCode?: number | undefined;
    daysFromInsem?: number | undefined;
    pregCheckOrdered?: boolean;
    barcode?: number;
    newPregCheckOrder?: boolean;

    constructor(data?: ISentBarcodeAnimalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bovineId = _data["bovineId"];
            this.earNr = _data["earNr"];
            this.nameShort = _data["nameShort"];
            this.euIdentifier = _data["euIdentifier"];
            this.euCheck = _data["euCheck"];
            this.lastPregCheckDate = _data["lastPregCheckDate"] ? new Date(_data["lastPregCheckDate"].toString()) : <any>undefined;
            this.lastPregnancyCode = _data["lastPregnancyCode"];
            this.daysFromInsem = _data["daysFromInsem"];
            this.pregCheckOrdered = _data["pregCheckOrdered"];
            this.barcode = _data["barcode"];
            this.newPregCheckOrder = _data["newPregCheckOrder"];
        }
    }

    static fromJS(data: any): SentBarcodeAnimalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SentBarcodeAnimalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bovineId"] = this.bovineId;
        data["earNr"] = this.earNr;
        data["nameShort"] = this.nameShort;
        data["euIdentifier"] = this.euIdentifier;
        data["euCheck"] = this.euCheck;
        data["lastPregCheckDate"] = this.lastPregCheckDate ? this.lastPregCheckDate.toISOString() : <any>undefined;
        data["lastPregnancyCode"] = this.lastPregnancyCode;
        data["daysFromInsem"] = this.daysFromInsem;
        data["pregCheckOrdered"] = this.pregCheckOrdered;
        data["barcode"] = this.barcode;
        data["newPregCheckOrder"] = this.newPregCheckOrder;
        return data;
    }
}

export interface ISentBarcodeAnimalDto {
    bovineId?: number;
    earNr?: number;
    nameShort?: string | undefined;
    euIdentifier?: string | undefined;
    euCheck?: string | undefined;
    lastPregCheckDate?: Date | undefined;
    lastPregnancyCode?: number | undefined;
    daysFromInsem?: number | undefined;
    pregCheckOrdered?: boolean;
    barcode?: number;
    newPregCheckOrder?: boolean;
}

export class SentBarcodeDto implements ISentBarcodeDto {
    fromTable?: BarcodesSendTo;
    testMilkDate!: Date;
    sentDate!: Date;
    barcodeCount?: number;
    pregCheckOrderCount?: number;
    animals?: SentBarcodeAnimalDto[] | undefined;

    constructor(data?: ISentBarcodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromTable = _data["fromTable"];
            this.testMilkDate = _data["testMilkDate"] ? new Date(_data["testMilkDate"].toString()) : <any>undefined;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.barcodeCount = _data["barcodeCount"];
            this.pregCheckOrderCount = _data["pregCheckOrderCount"];
            if (Array.isArray(_data["animals"])) {
                this.animals = [] as any;
                for (let item of _data["animals"])
                    this.animals!.push(SentBarcodeAnimalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SentBarcodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SentBarcodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromTable"] = this.fromTable;
        data["testMilkDate"] = this.testMilkDate ? this.testMilkDate.toISOString() : <any>undefined;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["barcodeCount"] = this.barcodeCount;
        data["pregCheckOrderCount"] = this.pregCheckOrderCount;
        if (Array.isArray(this.animals)) {
            data["animals"] = [];
            for (let item of this.animals)
                data["animals"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISentBarcodeDto {
    fromTable?: BarcodesSendTo;
    testMilkDate: Date;
    sentDate: Date;
    barcodeCount?: number;
    pregCheckOrderCount?: number;
    animals?: SentBarcodeAnimalDto[] | undefined;
}

export class TrackEvent implements ITrackEvent {
    message?: string | undefined;
    context?: string | undefined;
    user?: string | undefined;

    constructor(data?: ITrackEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.context = _data["context"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): TrackEvent {
        data = typeof data === 'object' ? data : {};
        let result = new TrackEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["context"] = this.context;
        data["user"] = this.user;
        return data;
    }
}

export interface ITrackEvent {
    message?: string | undefined;
    context?: string | undefined;
    user?: string | undefined;
}

export class UpdatePregnancyCheckOrdersCommand implements IUpdatePregnancyCheckOrdersCommand {
    herdId?: number;
    userId?: string | undefined;
    sendTo?: BarcodesSendTo;
    testMilkDate?: Date;
    data?: BarcodeDataToSaveDto[] | undefined;

    constructor(data?: IUpdatePregnancyCheckOrdersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.herdId = _data["herdId"];
            this.userId = _data["userId"];
            this.sendTo = _data["sendTo"];
            this.testMilkDate = _data["testMilkDate"] ? new Date(_data["testMilkDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BarcodeDataToSaveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePregnancyCheckOrdersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePregnancyCheckOrdersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["herdId"] = this.herdId;
        data["userId"] = this.userId;
        data["sendTo"] = this.sendTo;
        data["testMilkDate"] = this.testMilkDate ? this.testMilkDate.toISOString() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdatePregnancyCheckOrdersCommand {
    herdId?: number;
    userId?: string | undefined;
    sendTo?: BarcodesSendTo;
    testMilkDate?: Date;
    data?: BarcodeDataToSaveDto[] | undefined;
}

export class UserHerdDto implements IUserHerdDto {
    idkar!: number;
    custId?: number;
    custName?: string | undefined;

    constructor(data?: IUserHerdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idkar = _data["idkar"];
            this.custId = _data["custId"];
            this.custName = _data["custName"];
        }
    }

    static fromJS(data: any): UserHerdDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserHerdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idkar"] = this.idkar;
        data["custId"] = this.custId;
        data["custName"] = this.custName;
        return data;
    }
}

export interface IUserHerdDto {
    idkar: number;
    custId?: number;
    custName?: string | undefined;
}

export class UserSettingsDto implements IUserSettingsDto {
    userCanSendToMMfi?: boolean;
    language?: string | undefined;

    constructor(data?: IUserSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCanSendToMMfi = _data["userCanSendToMMfi"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UserSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCanSendToMMfi"] = this.userCanSendToMMfi;
        data["language"] = this.language;
        return data;
    }
}

export interface IUserSettingsDto {
    userCanSendToMMfi?: boolean;
    language?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}